export const configKeys = {
	PREFIX: 'prefix',
	API_DOMAIN: 'apiDomain',
	API_DOMAIN_V2: 'apiDomainV2',
	API_KEY: 'apiKey',
	CUSTOMER_ID: 'customerId',
	API_GRAPHQL_ENDPOINT: 'apiGraphqlEndpoint',
};
